import { Box, Flex, Image, Text, VStack, HStack, Icon } from "@chakra-ui/react";
import { MdLocationOn, MdPhone } from "react-icons/md";

export default function Footer2() {
  return (
    <Box bg="#0B1D39" color="white" py={10} px={{ base: 6, md: 16 }}>
      <Flex
        direction={{ base: "column", md: "row" }}
        justify="space-between"
        align="center"
        gap={10}
      >
        {/* Left - Logo + Info */}
        <VStack align="flex-start" spacing={4} flex="1">
          <Image
            src="/pentagon-white-logo.png" // replace with your footer logo
            alt="Pentagon Logo"
            h="40px"
            objectFit="contain"
          />
          <Text fontSize="sm">The touch and feel home solutions</Text>

          <HStack align="center" spacing={2}>
            <Icon as={MdLocationOn} boxSize={5} />
            <Text fontSize="sm">
              16/I/P, near, ESDS circle, MIDC, Satpur Colony, <br />
              Nashik, Maharashtra 422007
            </Text>
          </HStack>

          <HStack align="center" spacing={2}>
            <Icon as={MdPhone} boxSize={5} />
            <Text fontSize="sm">07378511300</Text>
          </HStack>
        </VStack>

        {/* Center - Copyright */}
        <VStack flex="1" textAlign="center">
          {/* <Text fontSize="sm">© 2025 Pentagon.in. All rights reserved.</Text> */}
        </VStack>

        {/* Right - QR Codes */}
        <HStack spacing={10} flex="1" justify="flex-end">
          <VStack spacing={2}>
            <Image
              src="/instagram-qr-pentagon.png"
              alt="Instagram QR"
              boxSize="100px"
              borderRadius="md"
              bg="white"
              p={1}
            />
            <Text fontSize="xs">Scan to follow us</Text>
          </VStack>

          <VStack spacing={2}>
            <Image
              src="/google-review-pentagon.png"
              alt="Google QR"
              boxSize="100px"
              borderRadius="md"
              bg="white"
              p={1}
            />
            <Text fontSize="xs">Scan to Review</Text>
          </VStack>
        </HStack>
      </Flex>
    </Box>
  );
}
